import * as React from "react";
import { CostOfCareCalculatorContext } from "./context/CostOfCareCalculatorState";
import { Bar } from 'react-chartjs-2';

export const SuburbPriceChartComponent = () => {

    const { state } = React.useContext(CostOfCareCalculatorContext)

    let minValue = state.suburbMin % Math.floor(state.suburbMin) > 0 ? state.suburbMin.toFixed(2) : state.suburbMin
    let maxValue = state.suburbMax % Math.floor(state.suburbMax) > 0 ? state.suburbMax.toFixed(2) : state.suburbMax
    let average = state.suburbAverage % Math.floor(state.suburbAverage) > 0 ? state.suburbAverage.toFixed(2) : state.suburbAverage

    const options = {
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            }
        },
        responsive: true,
        scales: {
            xAxis: {
                display: false,
            },
            yAxis: {
                ticks: {
                    display: false,
                },
                display: false,
            },
        },
    }

    let data = {
        labels: state.suburbChartData.chartLabels,
        datasets: [{
            data: state.suburbChartData.chartValues,
            backgroundColor: state.suburbChartData.chartColors,
        }],
    }

    return (
        <React.Fragment>
            <div className="hidden lg:flex w-full flex-col">
                <div className="text-lg text-skin-heading font-semibold mb-5">{state.suburbName} daily price spread</div>

                <div className="mb-2">
                    <div className="w-full">
                        <Bar
                            data={data}
                            options={options}
                        />
                    </div>
                </div>

                <div className="flex justify-between items-center gap-2 space-x-3">
                    <div className="mt-auto">
                        <div className="text-base-15">${minValue}</div>
                        <div className="text-xs leading-half">min</div>
                    </div>
                    <div className="flex justify-center items-center gap-2">
                        <div className="w-3 h-2 bg-skin-magenta"></div>
                        <p className="text-sm text-skin-autocomplete-mark"><span className="font-bold">${average}</span> Suburb Average</p>
                    </div>
                    <div className="mt-auto">
                        <div className="text-base-15">${maxValue}</div>
                        <div className="text-xs leading-half text-right">max</div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}